import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import Touch from 'vuetify/lib/directives/touch'
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify ({
  icons:{
    iconfont: 'mdi' 
  },
  directives: {
    Touch
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.red.darken4,
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: colors.red.base
      },
      dark: {
        primary: colors.red.darken4,
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: colors.red.base
      }
    }    
  }
})
